<template>
  <div>
    <div class="p_f t_h d_f ali_c" :class="getClass()" v-if="!urlShare">
      <div v-if="!isBg" class="t_l">
        <img src="../assets/img/th_back_white.png" alt="" class="cur_p back" @click="revert" v-if="isBackWhite || isBlue">
        <img src="../assets/img/th_back.png" alt="" class="cur_p back" @click="revert" v-else>
      </div>
      <div v-else class="t_l">
        <img src="../assets/img/back_bg.png" alt="" class="cur_p back_bg" @click="revert">
      </div>
      <span class="t_a flex_1">{{name}}</span>
      <span v-if="!isBg" class="t_r tr_w">
      <img v-if="isCollect & !collectState" src="../assets/img/th_collect.png" alt="" class="cur_p collect" @click="collect">
      <img v-if="isCollect & collectState" src="../assets/img/sq_sc.png" alt="" class="cur_p collect"  @click="cancelCollect">
      <img v-if="isShare && !isBlue" src="../assets/img/th_shar.png" :class="isCollect ? 'hasc' : ''" alt="" class="cur_p share" @click="share">
      <img v-if="isBlue" src="../assets/img/th_share_white.png" alt="" class="cur_p share" @click="share">
    </span>
      <span v-else>
      <img v-if="isCollect & !collectState" src="../assets/img/th_collet_bg.png" alt="" class="cur_p collect_bg" @click="collect">
      <img v-if="isCollect & collectState" src="../assets/img/sq_sc.png" alt="" class="cur_p collect_bg_star"  @click="cancelCollect">
      <img v-if="isShare" src="../assets/img/share_bg.png" alt="" class="cur_p share_bg" @click="share">
    </span>
    </div>
    <div v-if="urlShare && showShare" class="url_share d_f ali_c">
      <van-icon name="cross" @click="showShare = false"/>
      <span class="flex_1">打开津滨海APP</span>
      <a class="cur_p url_share_btn" @click="openApp">打开</a>
    </div>
    <div class="sharePop" v-show="showPopShare">
      <img src="../assets/img/share_right.png" alt="">
      <div>
        点击右上角“...”
        选择在浏览器中打开
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: "TopHead",
    props:{
      name:{//标题
        type:String,
        default:''
      },
      shareName:{
        type:String,
        default:'游滨城'
      },
      shareImg:{
        type:String,
        default:''
      },
      shareText:{
        type:String,
        default:'游滨城'
      },
      isShare:{//标题
        type:Boolean,
        default:false
      },
      isBackWhite:{//标题
        type:Boolean,
        default:false
      },
      isF5:{//标题
        type:Boolean,
        default:false
      },
      isBg:{//标题
        type:Boolean,
        default:false
      },
      colorState:{//标题
        type:Boolean,
        default:false
      },
      isBlue:{//标题
        type:Boolean,
        default:false
      },
      isCollect:{//标题
        type:Boolean,
        default:false
      },
      collectState:{//标题
        type:Number,
        default:0
      },
      collectId:{//标题
        type:Number,
        default:0
      },
      collectType:{//标题
        type:String,
        default:0
      },
      isBb:{//标题
        type:Boolean,
        default:false
      },
    },
    data() {
      return {
        urlShare:this.$route.query.share,
        showShare:true,
        showPopShare:false,
        isDestroyed:false,
      }
    },
    beforeUnmount(){
      this.isDestroyed = true;
    },
    created(){
    },
    methods: {
      revert(){
        if (window.history.length <= 1) {
          this.backApp()
          return false
        } else {
          this.$router.go(-1)
        }
        //上面都没执行就说明卡在当前页不是最后一条， histroy记录数量大于1，又没有回退记录，只能返回首页，
        //如果上面都执行了 页面都跳走了，这个也就不用管了

        setTimeout(() => {
          if(this && !this.isDestroyed){//isDestroyed 组件是否被销毁
            this.backApp()
          }
        },1000)
      },
      backApp(){
        localStorage.removeItem('map');
        // localStorage.clear()
        if(this.$global.modelState){
          window.android.exit();
        }else {
          this.$iosMethod(function(bridge) {
            bridge.callHandler('exit', null,function(data) {

            })
          })
        }
      },
      // 打开APP
      openApp() {
        let ua = navigator.userAgent.toLowerCase();
        console.log(ua);
        if(this.isWeixinBrowser(ua)){
          this.showPopShare = true
        }else{
          if(this.isAndroid(ua)){
            //android
            // 安卓：com.sh.tjtour
            // iOS：com.sh.tjtouretest
            window.location = 'com.sh.tjtour';
            let loadDateTime = Date.now();
            let turn = setTimeout(function(){
              let timeOutDateTime = Date.now();
              if ((timeOutDateTime - loadDateTime) < 1000 ){
                window.location = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.pdmi.binhai.media'
              }
            },600);
          }else{
            //ios
            window.location = 'com.sh.tjtouretest';
            let loadDateTime = Date.now();
            let turn = setTimeout(function(){
              let timeOutDateTime = Date.now();
              if ((timeOutDateTime - loadDateTime) < 1000 ){
                window.location = 'https://apps.apple.com/cn/app/%E6%B4%A5%E6%BB%A8%E6%B5%B7/id1458466709';
              }
            },600);
          }
        }
      },
      isWeixinBrowser(ua) {
        return (/micromessenger/.test(ua)) ? true : false;
      },
      isAndroid(ua) {
        return ua.indexOf('android') > -1 || ua.indexOf('linux') > -1;
      },
      getClass(){
        if(this.isBg && !this.colorState){
          return ' trans'
        }else if(this.isBg && this.colorState){
          return ' bg_Blue'
        }
        if(this.isBackWhite){
          return ' trans'
        }
        if(this.isF5){
          return ' bg_f5'
        }
        if(this.isBlue){
          return ' bg_Blue'
        }
        if(this.isBb){
          return ' bb'
        }
      },
      share(){
        //餐厅 RestaurantInner &share=1
        //美食 foodInner &share=1
        //景区详情 stDetail &share=1
        //酒店内页 hotelInner &share=1
        //酒店详情 hotelDetail &share=1
        //免税店商场内页 shoppingInner &share=1
        let _t = this;
        let　num = window.location.href.indexOf("?"),siteUrl;
        if(num>-1){
          siteUrl = window.location.href+'&share=1'
        }else{
          siteUrl = window.location.href+'?share=1'
        }
        let send = {
          'title':_t.shareName,
          'content':_t.shareText,
          'imageUrl':_t.shareImg,
          'url':siteUrl
        };
        if(_t.$global.modelState){
          window.android.share(
            `${send.title}`,
            `${send.content}`,
            `${send.imageUrl}`,
            `${send.url}`
          );

        }else{
          _t.$iosMethod(function(bridge) {
            bridge.callHandler('share', JSON.stringify(send),function(data) {
              _t.$global.loactions = data?data:null;
            })
          })
        }
      },
      //取消收藏
      cancelCollect(){
        this.$api.delCollect([this.collectId]).then(res => {
          // this.$api.delCollect([125792]).then(res => {
          this.$toast('取消收藏操作成功');
          this.$emit('collectSuc')
        })
      },
      collect(){
        if(!this.$global.token){
          if(this.$global.modelState){
            window.android.openLoginAction();
          }else {
            this.$iosMethod(function(bridge) {
              bridge.callHandler('openLoginAction', null,function(data) {

              })
            })
          }
        }else{
          this.$api.addCollect({targetId:this.$route.query.id,targetType:this.collectType}).then(res => {
            this.$toast('收藏成功');
            this.$emit('collectSuc')
          })
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .sharePop{
    div{
      font-size: 30px;
      text-align: center;
      padding-top: 100px;
    }
    img{
      position: absolute;
      right: 30px;
      top: 0;
      width: 100px;
    }
    color: white;
    position: fixed;
    z-index: 99999999;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.70);
  }
  .url_share{
    .url_share_btn{
      height: 45px;
      padding: 5px 25px;
      background-color: rgb(105, 201, 255);
    }
    span{
      margin-left: 15px;
    }
    position: fixed;
    z-index: 99999;
    background-color: #4C90F1;
    width: 100%;
    height: 100px;
    padding: 0 20px;
    box-sizing: border-box;
    top: 0;
    left: 0;
    color: white;
    font-size: 30px;
  }
  .t_h{
    &.bb{
      border-bottom: 1px solid #D0D0D0;
    }
    &.bg_f5{
      background-color: #f5f5f5;
    }
    &.bg_Blue{
      color: white;
      background-color: #4C90F1;
    }
    &.trans{
      background-color: rgba(0,0,0,0);
      color: white;
    }
    .share{
      width: 30px;
      height: 30px;
      &.hasc{
        margin-left: 28px;
      }
    }
    .collect{
      width: 33px;
      height: 32px;
    }
    .collect_bg_star{
      width: 45px;
      height: 45px;
      position: relative;
      top: -8px;
    }
    .collect_bg{
      width: 58px;
      height: 58px;
      margin-left: 25px;
    }
    .share_bg{
      width: 58px;
      height: 58px;
      margin-left: 25px;
    }
    .tr_w{
      width: 159px;
    }
    .back_bg{
      width: 59px;
      height: 58px;
    }
    .back{
      width: 19px;
      height: 34px;
    }
    >div{
      width: 160px;
    }
    font-size: 36px;
    font-weight: bold;
    color: #3E3E3E;
    height: 85px;
    width: 100%;
    background-color: white;
    left: 0;
    top: 0;
    z-index: 100000;
    padding: 29px 25px;
    box-sizing: border-box;
  }

</style>
